import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mr-3 model-summary-avatar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "flex-grow-1 min-width-0" }
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex flex-wrap align-center" }
const _hoisted_10 = { class: "text-caption text-medium-emphasis" }
const _hoisted_11 = {
  key: 2,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_12 = { class: "text-body-2" }
const _hoisted_13 = {
  key: 0,
  class: "system-model-overlay"
}
const _hoisted_14 = {
  key: 1,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_ModelOptionsChoices = _resolveComponent("ModelOptionsChoices")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_IconToggle = _resolveComponent("IconToggle")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0 pa-2 card",
    color: "background",
    variant: "elevated",
    elevation: _ctx.isOverlay ? 0 : 4,
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0 card-content",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
        density: "compact"
      }, {
        default: _withCtx(() => [
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "model-summary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = true))
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: (_ctx.icon as ProviderIcon).src,
                          alt: `${_ctx.providerKey || 'model'} icon`,
                          class: "model-summary-avatar-image",
                          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                        }, null, 40, _hoisted_2))
                      : (_ctx.showStandaloneIcon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "model-summary-avatar-mask",
                            style: _normalizeStyle(_ctx.iconMaskStyle),
                            role: "img",
                            "aria-label": `${_ctx.providerKey || 'model'} icon`
                          }, null, 12, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "model-summary-provider",
                            style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                          }, _toDisplayString(_ctx.providerInitials), 5))
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1),
                      (_ctx.programmaticToolCalling)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "x-small",
                            color: "info",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("Tools")
                            ])),
                            _: 1,
                            __: [11]
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isSystemModel)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            size: "x-small",
                            color: "warning",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("System")
                            ])),
                            _: 1,
                            __: [12]
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.configuredModelRetired)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 2,
                            size: "x-small",
                            color: "warning",
                            variant: "tonal",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode(" retired model ")
                            ])),
                            _: 1,
                            __: [13]
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.providerKey || 'No provider') + " · " + _toDisplayString(_ctx.modelName || 'No API model selected'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "pt-0 pb-0 model-summary-pricing"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_ctx.pricingLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Loading pricing…"))
                        : (_ctx.pricingRecord)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  variant: "tonal",
                                  class: "mr-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" In " + _toDisplayString(_ctx.inputPricingLabel), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  variant: "tonal",
                                  class: "mr-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Out " + _toDisplayString(_ctx.outputPricingLabel), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.pricingTierLabel)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "small",
                                      variant: "outlined",
                                      class: "mr-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.pricingTierLabel), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.pricingRecord.displayName), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, "Pricing unavailable"))
                    ]),
                    (!_ctx.isOverlay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "primary",
                          icon: "mdi-chevron-down",
                          size: "large",
                          variant: "plain",
                          class: "model-summary-expand",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.show = true), ["stop"]))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 pa-0 card-content",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select the configured provider for this model."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [14]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.providerKey,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.providerKey) = $event)),
                          _ctx.providerChanged
                        ],
                        items: _ctx.providerKeys,
                        label: "Provider",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        readonly: _ctx.isSystemModel,
                        rules: [() => !!_ctx.providerKey || 'Provider is required']
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "readonly", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select the specific model from the chosen provider's available models. Use the sync button to refresh the list."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [15]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.modelName,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelName) = $event)),
                          _ctx.modelSelected
                        ],
                        onBlur: _ctx.checkHash,
                        items: _ctx.models,
                        "item-title": "id",
                        "item-value": "id",
                        label: "Provider Models",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        disabled: _ctx.isSystemModel || !_ctx.providerKey,
                        loading: _ctx.modelsLoading,
                        readonly: _ctx.modelsLoading,
                        rules: [() => !!_ctx.modelName || 'Provider model is required']
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_Button, {
                            color: "primary",
                            buttonClass: "ml-n2",
                            click: _ctx.syncModels,
                            disabled: _ctx.syncDisabled,
                            icon: "mdi-sync",
                            size: "x-large",
                            tooltip: "Sync Models"
                          }, null, 8, ["click", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onBlur", "onUpdate:modelValue", "items", "disabled", "loading", "readonly", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.selectedModelRetired && !_ctx.isSystemModel)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: "ma-0 pa-0",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            type: "warning",
                            density: "compact",
                            variant: "tonal",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" \"" + _toDisplayString(_ctx.modelName) + "\" is no longer offered by " + _toDisplayString(_ctx.providerKey) + ". Generation with this model will fail — select a current model above, then save. ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "The Model Name defined here must be unique among your models and will appear in the models list for each agent once saved."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [16]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                            onBlur: _ctx.checkHash,
                            label: "Model Name",
                            class: "pt-2",
                            rules: _ctx.modelNameRules,
                            variant: "outlined",
                            density: "compact",
                            readonly: _ctx.isSystemModel || !_ctx.isCopy,
                            clearable: !_ctx.isSystemModel && _ctx.isCopy
                          }, {
                            "append-inner": _withCtx(() => [
                              (_ctx.name == null || _ctx.name == '')
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    text: "Autofill from selected API model"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps(props, {
                                        color: "primary",
                                        icon: "mdi-lightning-bolt-outline",
                                        onClick: _ctx.autofillName
                                      }), null, 16, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onBlur", "rules", "readonly", "clearable"])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "A brief description of the model. You can click the bolt at the end of the field to autofill the description."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [17]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.description,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.description) = $event)),
                            loading: _ctx.loading,
                            disabled: _ctx.loading || _ctx.isSystemModel,
                            class: "pt-2",
                            onBlur: _ctx.checkHash,
                            label: "Model Description",
                            variant: "outlined",
                            density: "compact"
                          }, {
                            "append-inner": _withCtx(() => [
                              _createVNode(_component_v_tooltip, { text: "Autofill (Not yet implemented)" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    color: "primary",
                                    icon: "mdi-lightning-bolt-outline",
                                    onClick: _ctx.autofillDescription
                                  }), null, 16, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "disabled", "onBlur"])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 3,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "Allow this model config to request provider-native programmatic tool calling when supported. Anthropic Sonnet/Opus 4.6+ use this today; the saved flag remains generic for future providers."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [18]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.programmaticToolCalling,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.programmaticToolCalling) = $event)),
                            label: "Programmatic Tool Calling",
                            "hide-details": "",
                            class: "display-inline",
                            disabled: _ctx.isSystemModel
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAdvanced && !_ctx.samplingParamsSupported)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 4,
                        class: "ma-0 pa-0",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            type: "warning",
                            density: "compact",
                            variant: "tonal",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.modelName) + " does not accept temperature or top-p. Those two parameters are ignored by the provider and are not saved with this model configuration. ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_ModelOptionsChoices, {
                        key: 5,
                        onUpdate: _ctx.updateOptions,
                        modelOptionsInput: _ctx.modelOptions,
                        modelName: _ctx.modelName,
                        hideSamplingParams: !_ctx.samplingParamsSupported
                      }, null, 8, ["onUpdate", "modelOptionsInput", "modelName", "hideSamplingParams"]))
                    : _createCommentVNode("", true),
                  (_ctx.response !== '' && _ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 6,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "After saving, the model will be prompted for an introduction, here is the response."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [19]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, {
                                title: "Model's introduction",
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.response), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 2,
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.saveDisabled,
                    click: _ctx.updateModel,
                    icon: "mdi-check-bold",
                    size: "x-large",
                    tooltip: "Save Model",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.isSystemModel,
                    click: _ctx.copyModel,
                    icon: "mdi-content-copy",
                    size: "x-large",
                    tooltip: "Copy Model",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.isSystemModel,
                    click: _ctx.initiateDeleteModel,
                    icon: "mdi-trash-can-outline",
                    size: "x-large",
                    tooltip: "Delete Model",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_IconToggle, {
                    value: _ctx.showAdvanced,
                    onValue: _ctx.toggleAdvanced,
                    tooltip: "Toggle advanced options",
                    highlightColor: "primary"
                  }, null, 8, ["value", "onValue"]),
                  (!_ctx.isOverlay)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        class: "mx-auto",
                        icon: "mdi-chevron-up",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.show = false)),
                        density: "compact"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.isSystemModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "mr-4" }, "System model", -1)),
            _createVNode(_component_v_tooltip, {
              "max-width": "300",
              text: "This model is provided by Mission Squad for your convenience and cannot be changed or removed.",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, { size: "medium" }), {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("mdi-information")
                  ])),
                  _: 2,
                  __: [20]
                }, 1040)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.waiting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmationDialog,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDeleteConfirmationDialog) = $event)),
        title: "Confirm Model Deletion",
        message: "Are you sure you want to delete this model configuration?",
        itemName: _ctx.modelNameToDelete,
        itemType: "model",
        loading: _ctx.waiting,
        onConfirm: _ctx.confirmModelDelete,
        onCancel: _ctx.cancelDeleteModel
      }, null, 8, ["modelValue", "itemName", "loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }, 8, ["elevation"]))
}